<div class="bg-white rounded-lg border border-gray-200 p-8 max-w-3xl mx-auto">
  <div class="flex flex-col items-center text-center mb-8">
    <!-- Ícono de check -->
    <div class="w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-6">
      <span class="h-8 w-8 text-white" style="font-size: 2rem;">&#10003;</span>
    </div>

    <!-- Título y subtítulo -->
    <h1 class="text-3xl font-bold text-primary mb-2">¡Felicidades! Tu unipay está lista</h1>
    <p class="text-gray-600">Has completado exitosamente el proceso de solicitud</p>
  </div>

  <!-- Mensaje informativo -->
  <div class="bg-gray-50 rounded-lg p-4 mb-8">
    <div class="flex items-start gap-2">
      <span class="h-5 w-5 text-gray-500 flex-shrink-0 mt-0.5">&#9432;</span>
      <p class="text-gray-600 text-sm">
        Tu Unipay ya está activa para compras presenciales. En 3 días hábiles, podrás usarla también online.
      </p>
    </div>
  </div>

  <!-- Resumen beneficiario -->
  <div class="border border-gray-200 rounded-lg p-6 mb-6">
    <h2 class="text-lg font-medium text-gray-700 text-center mb-6">Resumen beneficiario</h2>
    <div class="space-y-3">
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Nombre:</span>
        <span class="text-gray-600">{{ userName }}</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">RUT:</span>
        <span class="text-gray-600">11.000.000-1</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Estado civil:</span>
        <span class="text-gray-600">SOLTERO</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Correo electrónico:</span>
        <span class="text-gray-600">micorreo&#64;mail.cl</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Teléfono contacto:</span>
        <span class="text-gray-600">{{ phoneNumber }}</span>
      </div>
    </div>
  </div>

  <!-- Resumen producto -->
  <div class="border border-gray-200 rounded-lg p-6 mb-8">
    <h2 class="text-lg font-medium text-gray-700 text-center mb-6">Resumen producto</h2>
    <div class="space-y-3">
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Cupo aprobado:</span>
        <span class="text-gray-600">$600.000</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Día de pago cada mes:</span>
        <span class="text-gray-600">{{ diaPago }}</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-700">Seguros contratados:</span>
        <span class="text-gray-600">
          {{ seguroOption === 'desgravamen' ? 'Seguro Desgravamen' : 'Sin seguros' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Botón de acción -->
  <div class="flex justify-center">
    <button class="btn bg-primary hover:bg-primary-dark text-white px-8 py-6 text-lg">
      Comenzar a utilizar Unipay
    </button>
  </div>
</div> 